import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import SessionManager from "../../../../utils/sessionManager";
import { showAccessDeniedAlert } from "../../../../utils/accessDenied";
import { showTokenExpiredAlert } from "../../../../utils/alert";

export const dayWiseScheduleList = createAsyncThunk('dayWiseScheduleList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `crop-schedule-variants`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                "has_schedule": "true",
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const dayWiseScheduleListSlice = createSlice({
    name: 'dayWiseScheduleList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(dayWiseScheduleList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                const payloadData = action.payload.data.data;
                state.data = payloadData?.rows ?? payloadData ?? [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(dayWiseScheduleList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default dayWiseScheduleListSlice.reducer;
